import { TIMESHEET_FETCH } from './../store/constants';
// import { success, error } from './../common/helpers/constanHelpers';
import { createSimpleAction } from './actionCreator';

const doFetchTimeSheets = createSimpleAction(TIMESHEET_FETCH);

export { doFetchTimeSheets };
